/**
 * Who is offered the preview controls in the account menu — the Starter plan preview and the
 * seat switcher alike. Narrower than the `isSupportUser` gate around them, because both rewrite
 * the session. Presentation only: `?preview_plan=` and `?preview_role=` still resolve for
 * anyone, and only ever downgrade.
 */
export const PREVIEW_AUDIENCE_EMAILS: ReadonlyArray<string> = [
  'ovidiu.cotorogea@nexoya.com',
  'dragos.sebestin@nexoya.com',
  'philipp.meier@nexoya.com',
  'peter.ivanov@nexoya.com',
];

/**
 * Fails CLOSED on a non-string — `user` is null through bootstrap, when this menu first renders.
 * Normalises both sides; Auth0 and the team payload disagree on case for the same human.
 */
export function canUsePreviewControls(email: unknown): boolean {
  if (typeof email !== 'string') return false;
  return PREVIEW_AUDIENCE_EMAILS.includes(email.trim().toLowerCase());
}
